// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maintenance {
  position: relative;
  z-index: 4000;
  min-height: calc(100vh - 64px);
  display: -moz-flex;
  display: flex;
  -moz-flex-direction: column;
  flex-direction: column;
}

.maintenance-container {
  padding: 40px 1rem;
  display: -moz-flex;
  display: flex;
  -moz-align-items: center;
  align-items: center;
  -moz-justify-content: center;
  justify-content: center;
  -moz-flex: 1 0 auto;
  flex: 1 0 auto;
  -moz-flex-direction: column;
  flex-direction: column;
  min-height: 100%;
  text-align: center;
}

.maintenance-image {
  max-width: 492px;
  height: 277px;
  width: 100%;
}

.message-section {
  width: 74%;
}

.message-subtitle {
  font-size: 34px;
  font-weight: 500;
  line-height: 38px;
  margin-top: 35px;
  color: #3a3a3a;
}

.message-content {
  font-size: 24px;
  line-height: 28px;
  margin-top: 22px;
  color: #535353;
  font-weight: 100;
}

svg {
  max-width: 492px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/maintenance/maintenance.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EAGA,kBAAA;EAEA,aAAA;EAIA,2BAAA;EAEA,sBAAA;AACF;;AAEA;EACE,kBAAA;EAGA,kBAAA;EAEA,aAAA;EAIA,wBAAA;EACA,mBAAA;EAIA,4BAAA;EACA,uBAAA;EAIA,mBAAA;EAEA,cAAA;EAIA,2BAAA;EAEA,sBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,WAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,WAAA;AACF","sourcesContent":[".maintenance {\n  position: relative;\n  z-index: 4000;\n  min-height: calc(100vh - 64px);\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -webkit-flex-direction: column;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.maintenance-container {\n  padding: 40px 1rem;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -webkit-align-items: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -webkit-justify-content: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1 0 auto;\n  -moz-box-flex: 1;\n  -moz-flex: 1 0 auto;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -webkit-flex-direction: column;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  min-height: 100%;\n  text-align: center;\n}\n\n.maintenance-image {\n  max-width: 492px;\n  height: 277px;\n  width: 100%;\n}\n\n.message-section {\n  width: 74%;\n}\n\n.message-subtitle {\n  font-size: 34px;\n  font-weight: 500;\n  line-height: 38px;\n  margin-top: 35px;\n  color: #3a3a3a;\n}\n\n.message-content {\n  font-size: 24px;\n  line-height: 28px;\n  margin-top: 22px;\n  color: #535353;\n  font-weight: 100;\n}\n\nsvg {\n  max-width: 492px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
